<template>
  <div>
    <div class="sub-header">
      <div class="header d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center">
          <h1 class="xxl">
            {{ resource["integration.HeaderText"] }}
          </h1>
        </div>
      </div>
    </div>
    <div class="page-view">
      <div class="container">
        <div class="integration">
          <div class="integration__header">
            <img :src="require('@/assets/hrVenue/ats-integrations.svg')" alt="integration" />
            <div class="integration__header-text">
              <h2>{{ resource["integration.IntegrationHeaderText"] }}</h2>
              <h2>{{ resource["integration.IntegrationHeaderTextSecond"] }}</h2>
              <p>{{ resource["integration.IntegrationHeaderDescription"] }}</p>
              <router-link
                v-if="!loading && !unifiedIsEnabled"
                class="bg-button"
                :to="{ name: 'ContactUs', params: { lang: $route.params.lang } }"
                ><span>{{ resource["contactUsButton"] }}</span></router-link>
            </div>
          </div>
          <vue-content-loading v-if="loading" :height="300" :speed="1">
            <template>
              <rect x="0" y="0" rx="4" ry="4" width="100%" height="120" />
              <rect x="0" y="136" rx="4" ry="4" width="100%" height="120" />
              <rect x="0" y="272" rx="4" ry="4" width="100%" height="120" />
            </template>
          </vue-content-loading>
          <div v-else>
            <UnifiedIntegration
              v-if="unifiedIsEnabled"
              workspace_id="6737006a98e7209098dc6319"
              environment="Sandbox"
              :scopes="['ats.job.read', 'ats.candidate.read']"
            />
            <div class="ats-integration" v-else>
              <div data-v-8487a12e="" class="ats-integration__items">
                <div data-v-8487a12e="" class="ats-integration-item">
                  <div data-v-8487a12e="" class="ats-integration-item__content"><img data-v-8487a12e=""
                      :src="require('@/assets/hrVenue/ashby.png')" alt="Ashby" width="48" height="48">
                    <div data-v-8487a12e="" class="ats-integration-item__text">
                      <p data-v-8487a12e="" class="ats-integration-item__title"> Ashby </p>
                    </div>
                  </div>
                </div>
                <div data-v-8487a12e="" class="ats-integration-item">
                  <div data-v-8487a12e="" class="ats-integration-item__content"><img data-v-8487a12e=""
                      :src="require('@/assets/hrVenue/bamboohr.svg')" alt="BambooHR" width="48" height="48">
                    <div data-v-8487a12e="" class="ats-integration-item__text">
                      <p data-v-8487a12e="" class="ats-integration-item__title"> BambooHR </p>
                    </div>
                  </div>
                </div>
                <div data-v-8487a12e="" class="ats-integration-item">
                  <div data-v-8487a12e="" class="ats-integration-item__content"><img data-v-8487a12e=""
                      :src="require('@/assets/hrVenue/breezyhr.png')" alt="BreezyHR" width="48" height="48">
                    <div data-v-8487a12e="" class="ats-integration-item__text">
                      <p data-v-8487a12e="" class="ats-integration-item__title"> BreezyHR <!----></p>
                    </div>
                  </div>
                </div>
                <div data-v-8487a12e="" class="ats-integration-item">
                  <div data-v-8487a12e="" class="ats-integration-item__content"><img data-v-8487a12e=""
                      :src="require('@/assets/hrVenue/greenhouse.png')" alt="Greenhouse" width="48" height="48">
                    <div data-v-8487a12e="" class="ats-integration-item__text">
                      <p data-v-8487a12e="" class="ats-integration-item__title"> Greenhouse </p>
                    </div>
                  </div>
                </div>
                <div data-v-8487a12e="" class="ats-integration-item">
                  <div data-v-8487a12e="" class="ats-integration-item__content"><img data-v-8487a12e=""
                      :src="require('@/assets/hrVenue/jazzhr.png')" alt="JazzHR" width="48" height="48">
                    <div data-v-8487a12e="" class="ats-integration-item__text">
                      <p data-v-8487a12e="" class="ats-integration-item__title"> JazzHR </p>
                    </div>
                  </div>
                </div>
                <div data-v-8487a12e="" class="ats-integration-item">
                  <div data-v-8487a12e="" class="ats-integration-item__content"><img data-v-8487a12e=""
                      :src="require('@/assets/hrVenue/successfactors.png')" alt="SAP SuccessFactors" width="48"
                      height="48">
                    <div data-v-8487a12e="" class="ats-integration-item__text">
                      <p data-v-8487a12e="" class="ats-integration-item__title"> SAP SuccessFactors </p>
                    </div>
                  </div>
                </div>
                <div data-v-8487a12e="" class="ats-integration-item">
                  <div data-v-8487a12e="" class="ats-integration-item__content"><img data-v-8487a12e=""
                      :src="require('@/assets/hrVenue/smartrecruiters.png')" alt="SmartRecruiters" width="48"
                      height="48">
                    <div data-v-8487a12e="" class="ats-integration-item__text">
                      <p data-v-8487a12e="" class="ats-integration-item__title"> SmartRecruiters </p>
                    </div>
                  </div>
                </div>
                <div data-v-8487a12e="" class="ats-integration-item">
                  <div data-v-8487a12e="" class="ats-integration-item__content"><img data-v-8487a12e=""
                      :src="require('@/assets/hrVenue/workable.png')" alt="Workable" width="48" height="48">
                    <div data-v-8487a12e="" class="ats-integration-item__text">
                      <p data-v-8487a12e="" class="ats-integration-item__title"> Workable </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import hrvenueService from '../../services/hrvenue.service';

// import UnifiedConnections from '../unified/UnifiedConnections.vue';
import UnifiedIntegration from '../unified/UnifiedIntegration.vue';

export default {
  name: 'Integrations',
  data() {
    return {
      passwordSetting: false,
      unifiedIsEnabled: false,
      loading: true,
    };
  },
  async created() {
    const unifiedIsEnabledResponse = await hrvenueService.getSettingKey(
      'FeatureManagement:UnifiedIsEnabled',
    );
    this.unifiedIsEnabled = unifiedIsEnabledResponse === 'True';
    this.loading = false;
  },
  components: {
    UnifiedIntegration,
    // UnifiedConnections,
  },

  computed: {},
  methods: {},
};
</script>

<style lang="scss" scoped>
@import "~@/style/starter.scss";

.container {
  &:has(.integration) {
    max-width: 100% !important;
    padding: 0 16px !important;

    @media only screen and (max-width: map-get($grid-breakpoints, "lg")) {
      padding: 0 !important;
    }
  }
}

.integration {
  border: 1px solid #E5E5E5;
  border-radius: 4px;
  background: #fff;
  width: 100%;

  @media only screen and (max-width: map-get($grid-breakpoints, "lg")) {
    max-width: 100% !important;
    margin-top: 16px;
  }

  &__header {
    display: flex;
    align-items: flex-start;
    margin-bottom: 24px;
    padding: 24px 16px 0 16px !important;

    @media only screen and (max-width: map-get($grid-breakpoints, "lg")) {
      flex-direction: column;
      align-items: center;
      gap: 8px
    }

    &-text {
      margin-left: 8px;

      h2 {
        max-width: 413px;
        color: var(--Text-Colors-Primary-Gray-Text, #333);
        font-feature-settings: 'liga' off, 'clig' off;
        /* Typography/Subtitle/1 - Bold */
        font-family: Roboto;
        font-size: 18px;
        font-style: normal;
        font-weight: 700;
        line-height: 24px;

        @media only screen and (max-width: map-get($grid-breakpoints, "lg")) {
          text-align: center;
          margin: 0 auto;
        }
      }

      p {
        max-width: 620px;
        color: var(--Text-Colors-Secondary-Gray-Text, #878787);
        font-feature-settings: 'liga' off, 'clig' off;
        text-overflow: ellipsis;
        /* Typography/Body/3 - Regular */
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
        margin-bottom: 0;
        margin-top: 4px;

        @media only screen and (max-width: map-get($grid-breakpoints, "lg")) {
          text-align: center;
        }
      }
    }
  }
}

.alert {
  max-width: 100% !important;
  margin-left: 0 !important;
  margin-top: 16px;
}

// unified integration
.ats-integration {
  display: flex;
  padding: 0 16px 16px 16px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  margin: 0 auto;

  &__title {
    display: flex;
    width: 100%;
    color: #353535;
    font-family: Ubuntu;
    font-size: 22px;
    font-weight: 500;
    line-height: 28px;
  }

  &__description {
    font-family: Ubuntu;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    color: #353535;
    text-align: center;
  }

  &__items {
    display: flex;
    width: 100%;
    align-items: stretch;
    gap: 16px;
    align-self: stretch;
    flex-wrap: wrap;

    @media only screen and (max-width: map-get($grid-breakpoints, "lg")) {
      gap: 16px
    }
  }

  &__button {
    border-radius: 4px;
    width: 214px;
    padding: 8px 22px;
    background: #FF8D06 !important;
    color: #FFFFFF;
    text-decoration: none;
    font-family: Ubuntu;
    font-size: 16px;
    font-weight: 500;
    line-height: 26px;
    letter-spacing: 0.46px;
    margin-top: 16px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    transition: all 0.2s ease-in-out;

    &:hover {
      background: #FF7415 !important;
    }

    &:disabled {
      background: #E4E4E4 !important;
      color: #353535 !important;
    }

    @media only screen and (max-width: map-get($grid-breakpoints, "lg")) {
      width: 100%;
    }
  }

}

.ats-integration-item {
  display: flex;
  flex-wrap: wrap;
  min-width: 304px;
  width: calc(100% / 3 - 11px);
  flex-direction: column;
  align-items: center;
  padding: 24px 24px 24px 16px;
  gap: 6px;
  border-radius: 4px;
  border: 1px solid #e5e5e5;
  background: #ffffff;
  position: relative;

  @media only screen and (max-width: map-get($grid-breakpoints, "lg")) {
    width: calc(100% / 2 - 8px);
    min-width: auto;
  }

  @media only screen and (max-width: map-get($grid-breakpoints, "md")) {
    width: 100%;
    min-width: auto;
  }

  &__content {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 12px;
    align-self: stretch;
    flex: 1;

    @media only screen and (max-width: map-get($grid-breakpoints, "md")) {
      flex-wrap: wrap;
    }
  }

  &__text {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
    flex: 1 0 0;
  }

  &__title {
    color: #353535;
    font-family: Ubuntu;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 22px;
    margin-bottom: 0;
    display: flex;
    align-items: center;
    flex: 1;

    @media only screen and (max-width: map-get($grid-breakpoints, "md")) {
      font-size: 14px;
    }
  }

  &__description {
    color: #878787;
    font-family: Ubuntu;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    margin-bottom: 0;
    flex: 1;
  }

  &__button {
    border-radius: 50px;
    width: 214px;
    padding: 8px 22px;
    background: transparent !important;
    color: #353535;
    border: 1px solid #353535;
    width: fit-content;
    min-width: fit-content;
    text-decoration: none;
    font-family: Ubuntu;
    font-size: 16px;
    font-weight: 500;
    line-height: 26px;
    letter-spacing: 0.46px;
    transition: all 0.2s ease-in-out;

    &:hover {
      background: #353535 !important;
      color: #FFFFFF !important;
    }

    &:disabled {
      background: #E4E4E4 !important;
      color: #353535 !important;
      cursor: not-allowed !important;
      pointer-events: auto !important;
    }
  }

  &__badge {
    position: absolute;
    height: 20px;
    right: 37px;
    bottom: 0px;
    display: flex;
    padding: 2px 8px;
    justify-content: center;
    align-items: center;
    gap: 2px;
    border-radius: 2px 2px 0 0;
    border: 1px solid #e4e4e4;
    background: #eeeeee;
  }

  &__badge-text {
    color: #353535;
    font-feature-settings: "liga" off, "clig" off;
    font-family: Ubuntu;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 16px;
  }
}

.bg-button {
  display: flex;
  padding: 6px 8px;
  justify-content: center;
  align-items: center;
  border-radius: 114px;
  border: 1px solid #ff8d06;
  background: #ff8d06;
  transition: all 0.2s ease-in-out;
  width: fit-content;
  margin-top: 12px;

  span {
    color: #fff;
    text-align: center;
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 18px;
    padding: 0 8px;
  }

  &.disabled {
    border-color: transparent;
  }

  &:hover {
    background: #FF7415 !important;
  }

  @media only screen and (max-width: map-get($grid-breakpoints, "lg")) {
    width: 100%;
  }
}

.border-button {
  display: flex;
  padding: 6px 8px;
  justify-content: center;
  align-items: center;
  border-radius: 114px;
  border: 1px solid #ff8d06;
  background: transparent;
  transition: all 0.2s ease-in-out;

  span {
    color: #ff8d06;
    text-align: center;
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 18px;
    padding: 0 8px;
  }

  &.disabled {
    border-color: transparent;
  }

  &:hover {
    background: #ff8d06;
    color: #fff !important;

    span {
      color: #fff !important;
    }
  }
}

.intructions-list {
  ::v-deep a {
    color: #FF8D06;
    text-decoration: underline;
  }

  li {
    margin-bottom: 16px;
  }
}

input[type="checkbox"] {
  position: relative;
  opacity: 1;
}

.switch-checkbox {
  --toggle-size: 16px;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  width: 42px;
  height: 22px;
  background: -webkit-gradient(linear,
      left top,
      right top,
      color-stop(50%, #C3C3C3),
      color-stop(50%, #FF8D06)) no-repeat;
  background: -o-linear-gradient(left, #C3C3C3 50%, #FF8D06 50%) no-repeat;
  background: linear-gradient(to right, #C3C3C3 50%, #FF8D06 50%) no-repeat;
  background-size: 205%;
  background-position: 0;
  -webkit-transition: 0.4s;
  -o-transition: 0.4s;
  transition: 0.4s;
  border-radius: 99em;
  position: relative;
  cursor: pointer;
  font-size: var(--toggle-size);

  &:focus-visible {
    outline: 0;
  }
}

.switch-checkbox::before {
  content: "";
  width: 13px;
  height: 13px;
  position: absolute;
  top: 4.5px;
  left: 5px;
  background: -webkit-gradient(linear,
      left top,
      right top,
      color-stop(50%, #fff),
      color-stop(50%, #fff)) no-repeat;
  background: -o-linear-gradient(left, #fff 50%, #fff 50%) no-repeat;
  background: linear-gradient(to right, #fff 50%, #fff 50%) no-repeat;
  background-size: 205%;
  background-position: 100%;
  border-radius: 50%;
  -webkit-transition: 0.4s;
  -o-transition: 0.4s;
  transition: 0.4s;
}

.switch-checkbox:checked::before {
  left: calc(100% - 16px - 2px);
  background-position: 0;
}

.switch-checkbox:checked {
  background-position: 100%;
}

::v-deep .disconnect-modal,
::v-deep .token-modal {
  .modal-dialog {
    width: 466px;
    max-width: 466px;

    @media only screen and (max-width: map-get($grid-breakpoints, "lg")) {
      width: 90%;
      max-width: 90%;
      margin: 0 auto;
    }
  }

  .modal-header {
    padding: 12px 12px 12px 24px !important;
  }

  .modal-body {
    padding: 16px 24px !important;

    ul {
      padding-left: 16px;
    }

    p {
      color: var(--Text-Colors-Primary-Gray-Text, #333);
      font-feature-settings: 'liga' off, 'clig' off;
      /* Typography/Body/3 - Regular */
      font-family: Roboto;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      margin-bottom: 0;
    }
  }

  .button-area {
    display: flex;
    gap: 16px;
    justify-content: flex-end;
    margin-top: 24px;
    width: 100%;

    @media only screen and (max-width: map-get($grid-breakpoints, "lg")) {
      flex-direction: column;
      flex: 1 1 100%;
    }
  }
}
</style>
